import { SaleType } from "@wix/ambassador-devcenter-managedapps-v1-managed-app/types";
export const mapSaleTypeToTooltipTitleKey = {
    [SaleType.NOVEMBER_SALE]: "manage-apps.app-card.discount-label.tooltip.title.november-sale",
    [SaleType.DEVELOPER_SALE]: "manage-apps.app-card.discount-label.tooltip.title.developer-sale",
    [SaleType.CYBER_MONDAY]: "manage-apps.app-card.discount-label.tooltip.title.cyber-monday-sale",
    [SaleType.UNKNOWN_SALE_TYPE]: "manage-apps.app-card.discount-label.tooltip.title.general",
    [SaleType.BLACK_FRIDAY]: "manage-apps.app-card.discount-label.tooltip.title.black-friday-sale",
};
//# sourceMappingURL=consts.js.map